import { render } from "./SpacingDemo.vue?vue&type=template&id=4f40b378&scoped=true"
import script from "./SpacingDemo.vue?vue&type=script&lang=js"
export * from "./SpacingDemo.vue?vue&type=script&lang=js"

import "./SpacingDemo.vue?vue&type=style&index=0&id=4f40b378&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f40b378"]])

export default __exports__